import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from '../../../../core/src/lib/store/store.service';
import { ApiService } from '../../../../core/src/lib/api/api.service';
import { takeWhile } from 'rxjs/operators';

export interface OrganizationDetails {
  organizationId: string | null;
  isOperatingMerchant: boolean;
  accessibleMerchantIds: string[];
  memberCount: number;
}

export interface MemberMerchant {
  id: number;
  name: string;
  merchantID: string;
  organizationId: string;
  isOperatingMerchant: boolean;
}

@Component({
  selector: 'ngx-organization-details',
  styleUrls: ['./organization-details.component.scss'],
  templateUrl: './organization-details.component.html',
})
export class OrganizationDetailsComponent implements OnInit, OnDestroy {
  private alive = true;

  sellerName = '';
  sellerID = 0;
  orgDetails: OrganizationDetails | null = null;
  members: MemberMerchant[] = [];
  loading = true;
  error: string | null = null;

  constructor(
    public store: StoreService,
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.store.seller$
      .pipe(takeWhile(() => this.alive))
      .subscribe((seller) => {
        if (seller) {
          this.sellerName = seller.name;
          this.sellerID = seller.id;
          this.loadOrganizationData(seller.id);
        } else {
          this.router.navigate(['pages', 'manage-sellers']);
        }
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  private loadOrganizationData(sellerID: number) {
    this.loading = true;
    this.error = null;

    this.api.getOrganizationDetails(sellerID).subscribe({
      next: (details) => {
        this.orgDetails = details;
        if (details?.isOperatingMerchant) {
          this.loadMembers(sellerID);
        } else {
          this.loading = false;
        }
      },
      error: (err) => {
        this.error = 'Failed to load organization details.';
        this.loading = false;
      },
    });
  }

  private loadMembers(sellerID: number) {
    this.api.getMemberMerchants(sellerID).subscribe({
      next: (response) => {
        this.members = response?.members || [];
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load member merchants.';
        this.loading = false;
      },
    });
  }

  viewMember(member: MemberMerchant) {
    this.store.setSeller(member as any);
    this.router.navigate(['pages', 'settings']);
  }

  goBack() {
    this.router.navigate(['pages', 'manage-sellers']);
  }
}
